import { combineEpics } from 'redux-observable';
import { fetchAllManufacturersEpic } from '@/store/epics/staff/assets/manufacturers/fetch-all-manufacturer.epic';
import { createManufacturerEpic } from '@/store/epics/staff/assets/manufacturers/create-manufacturer.epic';

export const combinedManufacturersEpics = combineEpics(fetchAllManufacturersEpic, createManufacturerEpic);
